import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

const primaryMenuItems = accountId => [
  {
    icon: 'chatwoot-ai',
    key: 'home',
    label: 'HOME',
    toState: frontendURL(`accounts/${accountId}/home`),
    toStateName: 'home_dashboard',
  },
  {
    icon: 'chat',
    key: 'conversations',
    label: 'CONVERSATIONS',
    toState: frontendURL(`accounts/${accountId}/dashboard`),
    toStateName: 'home',
  },
  {
    icon: 'filter',
    key: 'pipeline',
    label: 'PIPELINE',
    toState: frontendURL(`accounts/${accountId}/pipeline`),
    toStateName: 'pipeline_kanban',
  },
  {
    icon: 'credit-card-person',
    key: 'ventas',
    label: 'VENTAS',
    toState: frontendURL(`accounts/${accountId}/ventas`),
    toStateName: 'ventas_view',
  },
  {
    icon: 'call',
    key: 'llamadas',
    label: 'LLAMADAS',
    toState: frontendURL(`accounts/${accountId}/llamadas`),
    toStateName: 'llamadas_view',
    requiredCapability: 'call_center_analytics',
  },
  {
    icon: 'people-team',
    key: 'mi_equipo',
    label: 'MI_EQUIPO',
    toState: frontendURL(`accounts/${accountId}/mi-equipo`),
    toStateName: 'mi_equipo_view',
  },
  {
    icon: 'box',
    key: 'catalogo',
    label: 'CATALOGO',
    toState: frontendURL(`accounts/${accountId}/catalogo`),
    toStateName: 'catalogo_view',
  },
  {
    icon: 'task-list-square-add',
    key: 'tareas',
    label: 'TAREAS',
    toState: frontendURL(`accounts/${accountId}/tareas`),
    toStateName: 'tareas_view',
  },
  {
    icon: 'megaphone',
    key: 'envio_masivo',
    label: 'ENVIO_MASIVO',
    toState: frontendURL(`accounts/${accountId}/envio-masivo`),
    toStateName: 'wa_campaigns_list',
  },
  {
    icon: 'automation',
    key: 'flows',
    label: 'FLOWS',
    toState: frontendURL(`accounts/${accountId}/flujos-v2`),
    toStateName: 'flows_v2_list',
  },
  {
    icon: 'globe',
    key: 'canales',
    label: 'CANALES',
    toState: frontendURL(`accounts/${accountId}/canales`),
    toStateName: 'canales_view',
  },
  {
    icon: 'bot',
    key: 'agente_ia',
    label: 'AGENTE_IA',
    toState: frontendURL(`accounts/${accountId}/agente-ia`),
    toStateName: 'agente_ia_view',
  },
  {
    icon: 'book-contacts',
    key: 'contacts',
    label: 'CONTACTS',
    featureFlag: FEATURE_FLAGS.CRM,
    toState: frontendURL(`accounts/${accountId}/contacts`),
    toStateName: 'contacts_dashboard',
  },
  {
    icon: 'settings',
    key: 'settings',
    label: 'SETTINGS',
    toState: frontendURL(`accounts/${accountId}/settings`),
    toStateName: 'settings_home',
  },
];

export default primaryMenuItems;
